import { debounce } from 'lodash';

class ViewportSetter {
  constructor() {
    this.init();
  }

  private resizer = debounce(() => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }, 300);

  public init() {
    this.resizer();
    window.addEventListener('resize', this.resizer);
  }
}

export { ViewportSetter };
